// Angular
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ItemService } from 'src/app/provider/item.service';
import { MenuItemModel } from 'src/app/views/models/menu-item.model';
import { MenuModel, MenuService } from '../../../../provider/menu.service';
import { AsideMenuModel, HeaderMenuModel, MenuConfig } from '../../../_config/menu.config';
import { MenuSectionService } from 'src/app/provider/menu-section.service';
import { MenuSectionModel } from 'src/app/views/models/menu-section.model';
import { TokenFormModel } from 'src/app/views/pages/auth/models/tokenform.model';

@Injectable({ providedIn: 'root' })
export class MenuConfigService {
  // Public properties
  onConfigUpdated$ = new BehaviorSubject<HeaderMenuModel[]>([]);
  // menu Config => get area end sections
  // menuConfig: HeaderMenuModel[];


  constructor(
    private menuService: MenuService,
    private menuConfig: MenuConfig,
    private itemServ: ItemService,
    private sectionServ: MenuSectionService
  ) {
  }

  loadConfigs() {
    this.menuConfig.headerMenuChange$.subscribe(
      (config: HeaderMenuModel[] | undefined) => {
        if (config != undefined) {
          this.menuService.menu_change$.subscribe(
            async (datas: MenuModel[]) => {
              if (datas.length == 0) {
                return;
              }
              if (config[0].page == '/home') {

                config[0].items = [];

                config[0].items.push(
                  { title: 'Home', icon: 'fas fa-home', page: '/home' },
                  { title: 'Orders', icon: 'fa fa-gift', page: '/home/requests' },
                );

                try {
                  const asideModel = new AsideMenuModel();
                  asideModel.submenu = undefined;
                  const ITEMS = await this.itemServ.getItemsWithSectionId(157) as MenuItemModel[];
                  asideModel.title = 'Menu';
                  asideModel.icon = 'fas fa-file-alt';

                  asideModel.page = `/home/menu-item/${ITEMS && ITEMS.length > 0 ? ITEMS[0].id : ''}`;

                  if (ITEMS && ITEMS.length > 0 && !config[0].items.find(x => x.page === asideModel.page)) {
                    const TOKEN: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));
                    if (TOKEN.role !== 'user') {
                      config[0].items.push(asideModel);
                      config[0].items.push(
                        { title: 'Products', icon: 'fas fa-shopping-cart', page: '/home/products' },
                        // { title: 'Reservation List', icon: 'fas fa-clipboard-list', page: '/home/reserve-list' },
                        { title: 'Live Support', icon: 'fas fa-comment', page: '/home/live-support' },
                        { title: 'Users', icon: 'fas fa-user', page: '/home/profiles' },
                        { title: 'SETUP', icon: 'fas fa-cogs', page: '/home/info' }
                      );
                    }
                    if (TOKEN.role === 'manager') {
                      config[0].items = [
                        { title: 'Home', icon: 'fas fa-home', page: '/home' },
                      ];
                    }

                  }

                } catch { }

                config[0].items = [...new Set(config[0].items)];
              }

              this.onConfigUpdated$.next(config);
            }
          );
          this.menuService.getMenu();
        }
      }
    );
  }
}
